// Wärtsilä Online translations exported from Salesforce. Please see "Translations" in Confluence for correct workflow.
import { ITranslations } from "../../localization";

// tslint:disable-next-line: variable-name
export const eula_ru: ITranslations = {
  ru: {
    "eula.acceptPrivacyStatement": "Я принимаю {privacyStatement}",
    "eula.acceptTermsAndConditions": "Я принимаю {termsAndConditions}",
    "eula.agreeButtonText": "Продолжение",
    "eula.cancelButtonText": "Отмена и выход из системы",
    "eula.caption": "Перед тем как можно будет использовать Wärtsilä Online, вам необходимо ознакомиться и согласиться с условиями положения о защите персональных данных.",
    "eula.privacyStatement": "Положение о защите персональных данных",
    "eula.termsAndConditions": "Положения и условия",
    "eula.title": "Принять положения и условия",
    "eula.validate.acceptPrivacyStatement": "Вы должны принять Положение о защите персональных данных",
    "eula.validate.acceptTermsAndConditions": "Вы должны принять положения и условия",
  },
};
